import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `MovimientoVerraco/getFiltrarMovimientoVerraco`, method: 'POST', body: values, token: token})
}
